module.exports = __webpack_public_path__ + "img/版·块·介·绍.d62e3963.png";